<div class="h-100 w-100 padt-5 container-scans cursor">
    <div class="vehicle-profile-header d-flex gap5">
        <div class="widget-title">{{widgetData?.title}}</div>
        <!-- <div class="widget-status">Excellent</div> -->
    </div>
    <div *ngIf="isloader" class="h-100 w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
      </div>
    <div class="chart-container" *ngIf="chartData?.length">
        <app-scatter-echart [xAxis]="scatterChartData?.xAxis" [yAxis]="scatterChartData?.yAxis" [series]="scatterChartData?.series" [grid]="scatterChartData?.grid" [toolbox]="scatterChartData?.toolbox" [tooltip]="scatterChartData?.tooltip"></app-scatter-echart>
    </div>
    <div class="no-data-text d-flex justify-content-center align-items-center" *ngIf="!chartData?.length && isError">
        Error! No Data!
    </div>
</div>

